import { CategoryForm } from "../CategoryForm";

export interface AddCategoryProps {}

export const AddCategory = () => {
  return <CategoryForm />;
};
